module.exports = __webpack_public_path__ + "img/Banner-Sidebar-Icon.281c1eb7.jpg";